// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const AppBarRoot = styled.header<{ withBorder?: boolean }>`
  position: relative;
  // top: 0;
  // right: 0;
  // left:10;
  // display: flex;
  align-items: center;
  justify-content: end;
  z-index: 40;
  width: 100%;
  height: 3rem;
  border-bottom: ${(props) =>
    props.withBorder ? "1px solid var(--mb-color-border)" : undefined};
  // background-color: blue;


  @media print {
    display: none;
  }
`;
